import styled from 'styled-components';

import style from '../../../../../style';

interface StyledParagraphProps {
  $isCurrent?: boolean;
}

export const StyledParagraph = styled.p<StyledParagraphProps>(
  ({ theme: { color, transition }, $isCurrent }) => ({
    color: color.content.secondary.default(),
    cursor: 'pointer',
    transition: transition.standard('color'),

    ...style.mixins.ellipsis(true),

    ...style.mixins.devices.desktop({
      '&:hover': {
        color: $isCurrent ? undefined : color.content.secondary.hover(),
      },
    }),
  }),
);

export const Wrapper = styled.div(({ theme: { size } }) => ({
  ':first-child': {
    minWidth: size.units(4),
  },

  ':last-child': {
    minWidth: size.units(13),
  },
}));
